export function intersects(a, b) {
    const aLeft = a.x;
    const aRight = a.x + a.width;
    const aTop = a.y;
    const aBottom = a.y + a.height;
    const bLeft = b.x;
    const bRight = b.x + b.width;
    const bTop = b.y;
    const bBottom = b.y + b.height;
    return aLeft < bRight && aRight > bLeft && aTop < bBottom && aBottom > bTop;
}
